'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Button } from '../ui/button';
import type { ReservationFormSchemaType, ReservationStepsProps } from './reservation-form';
import type { UseFormReturn } from 'node_modules/react-hook-form/dist/types';
import { Spinner } from '@eliadmin/core/src/components/ui/spinner';

interface ReservationFormFooterProps {
  currentStep: number;
  goToPreviousStep: () => void;
  goToNextStep: () => void;
  RESERVATION_STEPS: ReservationStepsProps[];
  isNextDisabled?: boolean;
  form: UseFormReturn<ReservationFormSchemaType>;
  isSubmitting: boolean;
}

export function ReservationFormFooter({
  currentStep,
  goToPreviousStep,
  goToNextStep,
  RESERVATION_STEPS,
  isNextDisabled = false,
  isSubmitting = false,
  form,
}: ReservationFormFooterProps) {
  return (
    <div className="grid w-full max-w-[400px] grid-cols-1 gap-2 sm:grid-cols-2">
      {currentStep > 1 && (
        <Button
          variant={'primary-foreground'}
          type="button"
          onClick={goToPreviousStep}
          className="col-span-1 w-full"
        >
          Späť
        </Button>
      )}

      {currentStep < RESERVATION_STEPS.length && (
        <Button
          type="button"
          onClick={goToNextStep}
          className={cn('w-full', currentStep > 1 ? 'col-span-1' : 'col-span-2')}
          variant={'dark'}
          disabled={isNextDisabled}
        >
          Ďalej
        </Button>
      )}

      {currentStep === RESERVATION_STEPS.length && (
        <Button
          type="submit"
          variant={'dark'}
          className="col-span-1 w-full"
          onClick={() => console.log(form.formState.errors)}
          disabled={isSubmitting || form.getValues().gdpr !== true || form.getValues().vop !== true}
        >
          {isSubmitting ? <Spinner /> : 'Odoslať rezerváciu'}
        </Button>
      )}
    </div>
  );
}
